import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=aa477dba"
import script from "./UploadDocument.vue?vue&type=script&lang=ts"
export * from "./UploadDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa477dba')) {
      api.createRecord('aa477dba', component.options)
    } else {
      api.reload('aa477dba', component.options)
    }
    module.hot.accept("./UploadDocument.vue?vue&type=template&id=aa477dba", function () {
      api.rerender('aa477dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/UploadDocument.vue"
export default component.exports